import { render, staticRenderFns } from "./RegimenCreatePreset.vue?vue&type=template&id=a8e72274"
import script from "./RegimenCreatePreset.vue?vue&type=script&lang=js"
export * from "./RegimenCreatePreset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports